import gql from "graphql-tag"

import dealLocation from "./fragments/dealLocation"
import userSavings from "./fragments/dealUserSavings"

const query = gql`
  query GeoDeals($q: String, $slim: Int, $geo: Int, $limit: Int, $insideBoundingBox: String) {
    geoDeals(q: $q, slim: $slim, geo: $geo, limit: $limit, insideBoundingBox: $insideBoundingBox) {
      count
      results {
        header
        locale
        thumbnailImage
        location {
          ...fullDealLocation
        }
        savings {
          ...userSavings
        }
        type
        urlSlug
        uuid
      }
    }
  }
  ${dealLocation}
  ${userSavings}
`

export default query
